import { render, staticRenderFns } from "./send-table.vue?vue&type=template&id=208da842&scoped=true&"
import script from "./send-table.vue?vue&type=script&lang=js&"
export * from "./send-table.vue?vue&type=script&lang=js&"
import style0 from "./send-table.vue?vue&type=style&index=0&id=208da842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208da842",
  null
  
)

export default component.exports